// extracted by mini-css-extract-plugin
export default {"location-infra-card":"LocationInfrastructure_location-infra-card__CKqh-","selected-location-infra-card":"LocationInfrastructure_selected-location-infra-card__bDsf4"};